import React from 'react';

function OrderFilters({ filters, onFilterChange, onApplyFilters, onClearFilters }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ ...filters, [name]: value });
  };

  return (
    <div className="order-filters">
      <div className="filter-row">
        <div className="filter-group">
          <label htmlFor="orderNumber">Número de Orden:</label>
          <input
            type="number"
            id="orderNumber"
            name="orderNumber"
            placeholder="Ej: 123"
            value={filters.orderNumber || ''}
            onChange={handleChange}
          />
        </div>

        <div className="filter-group">
          <label htmlFor="status">Estado:</label>
          <select
            id="status"
            name="status"
            value={filters.status || ''}
            onChange={handleChange}
          >
            <option value="">Todos</option>
            <option value="PENDIENTE">Pendiente</option>
            <option value="EN_PROCESO">En Proceso</option>
            <option value="ENVIADA">Enviada</option>
            <option value="RECIBIDA">Recibida</option>
          </select>
        </div>

        <div className="filter-group">
          <label htmlFor="fromDate">Desde:</label>
          <input
            type="date"
            id="fromDate"
            name="fromDate"
            value={filters.fromDate || ''}
            onChange={handleChange}
          />
        </div>

        <div className="filter-group">
          <label htmlFor="toDate">Hasta:</label>
          <input
            type="date"
            id="toDate"
            name="toDate"
            value={filters.toDate || ''}
            onChange={handleChange}
          />
        </div>

        <div className="filter-group">
          <label htmlFor="sortBy">Ordenar por:</label>
          <select
            id="sortBy"
            name="sortBy"
            value={filters.sortBy || 'createdAt'}
            onChange={handleChange}
          >
            <option value="createdAt">Fecha de creación</option>
            <option value="statusChangedAt">Fecha de cambio de estado</option>
          </select>
        </div>

        <div className="filter-group">
          <label htmlFor="sortDirection">Orden:</label>
          <select
            id="sortDirection"
            name="sortDirection"
            value={filters.sortDirection || 'desc'}
            onChange={handleChange}
          >
            <option value="desc">Descendente</option>
            <option value="asc">Ascendente</option>
          </select>
        </div>
      </div>

      <div className="filter-actions">
        <button onClick={onApplyFilters} className="btn btn-primary">
          Aplicar Filtros
        </button>
        <button onClick={onClearFilters} className="btn btn-secondary">
          Limpiar
        </button>
      </div>
    </div>
  );
}

export default OrderFilters;
